export default ($locationProvider, $routeProvider, $windowProvider) => {
    'ngInject';
    $locationProvider.html5Mode(true);
    let $window = $windowProvider.$get();
    if(!$window.disableOutput) {
        $routeProvider
            .when('/outputs/newsletter/:outputId/distributions', {
                activeTab: 'output_mgr',
                // GYDA-32355 - Tier 3 Fix - Begins
                template: '<mw-newsletter-distributions layout="column" class="mw-fab-container"></mw-newsletter-distributions>',
                // GYDA-32355 - Tier 3 Fix - Ends
                useMaterial: true,
                hideSubTabs: true
            });
    }
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distributions.route.config.ts
 **/